import { render, staticRenderFns } from "./SettingsTabSyncs.vue?vue&type=template&id=72b24da4"
import script from "./SettingsTabSyncs.vue?vue&type=script&lang=js"
export * from "./SettingsTabSyncs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports